<template>
  <Sidebar
    :visible="visible"
    @update:visible="onToggle"
    class="w-full sm:w-40rem"
    position="right"
    header="Voice Profile"
    :pt="{
      content: {
        class: 'flex flex-column'
      }
    }"
    blockScroll
  >
    <div class="flex flex-column flex-grow-1 overflow-y-auto overflow-x-hidden">
      <div>
        Choose the voice profile that will be used to read ads.
      </div>
      <div className="mt-3">
        You may choose an existing voice profile,
        add a new voice profile, or invite a host user
        and have them setup their own voice profile.
      </div>
      <div class="flex justify-content-end mt-3">
        <Button
          class="text-wrap-nowrap"
          outlined
          label="Invite Host User"
          @click="onInviteUserClick"
        />
        <Button
          class="text-wrap-nowrap ml-2"
          label="Add Voice Profile"
          @click="onAddUserClick"
        />
      </div>
      <Listbox
        class="mt-3"
        :modelValue="hostUserId"
        :options="hostUserOptions"
        optionLabel="label"
        optionValue="value"
        filter
        @update:modelValue="($event) => {
          if ($event) {
            $emit('update:hostUserId', $event)
          }
        }"
      >
        <template #option="slotProps">
          <div class="flex align-items-center justify-content-between">
              <div>{{ slotProps.option.label }}</div>
              <Button
                icon="pi pi-pencil"
                text
                plain
                size="small"
                v-tooltip.left="'Edit Voice Profile'"
                @click="() => onEditUserClick(slotProps.option)"
              />
          </div>
          <WarningMessage
            v-if="hostUserId === slotProps.option.value
              && !slotProps.option.user.voice_id"
            class="mt-2"
            severity="secondary"
          >
            The voice profile you have chosen does not have a voice configured.
            You must configure a voice before your podcast can start receiving ad campaigns.
          </WarningMessage>
        </template>
      </Listbox>
    </div>
    <div class="flex justify-content-end pt-2">
      <Button
        label="Close"
        text
        plain
        @click="() => onToggle(false)"
      />
    </div>
  </Sidebar>

  <VoiceProfileSidebar
    v-model:visible="addVoiceProfileSidebar.visible"
    @selectUserId="(userId) => $emit('update:hostUserId', userId)"
  />

  <VoiceProfileSidebar
    v-model:visible="editVoiceProfileSidebar.visible"
    :user="editVoiceProfileSidebar.user"
    @selectUserId="(userId) => $emit('update:hostUserId', userId)"
  />

  <InviteUserSidebar
    v-model:visible="inviteUserSidebar.visible"
    @selectUserId="(userId) => $emit('update:hostUserId', userId)"
  />
</template>

<script>
import VoiceProfileSidebar from './voiceProfileSidebar';
import InviteUserSidebar from './inviteUserSidebar';

export default {
  components: {
    VoiceProfileSidebar,
    InviteUserSidebar,
  },
  props: {
    visible: Boolean,
    hostUserId: {
      validator: (prop) => typeof prop === 'number' || prop === null,
    },
    hostUserOptions: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      addVoiceProfileSidebar: {
        visible: false,
      },
      editVoiceProfileSidebar: {
        visible: false,
        user: null,
      },
      inviteUserSidebar: {
        visible: false,
      },
    };
  },
  methods: {
    onToggle(visible) {
      this.$emit('update:visible', visible);
    },
    onAddUserClick() {
      this.addVoiceProfileSidebar.visible = true;
    },
    onEditUserClick({ user }) {
      this.editVoiceProfileSidebar.visible = true;
      this.editVoiceProfileSidebar.user = user;
    },
    onInviteUserClick() {
      this.inviteUserSidebar.visible = true;
    },
  },
};
</script>
